import { Link } from 'react-router-dom';
import type { Drama } from '@/mocks/dramas';

interface DramaCardProps {
  drama: Drama;
}

export default function DramaCard({ drama }: DramaCardProps) {
  return (
    <Link
      to={`/drama/${drama.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={drama.posterImage}
          alt={drama.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 right-2 bg-foreground-950/80 backdrop-blur-sm text-background-50 text-xs font-bold px-2 py-1 rounded-md whitespace-nowrap">
          {drama.rating}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-3 pt-8">
          <span className="text-background-50 text-xs font-medium bg-primary-500 px-2 py-0.5 rounded whitespace-nowrap">
            {drama.category}
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1 whitespace-nowrap">
          {drama.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500 whitespace-nowrap">{drama.year}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{drama.totalEpisodes}集</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-accent-600 font-medium whitespace-nowrap">{drama.updateStatus}</span>
        </div>
      </div>
    </Link>
  );
}